import { createSlice } from '@reduxjs/toolkit';

type InstallButtonProps = {
	deferredPrompt: any;
};

const initialState = false;

const tablaMobileSlice = createSlice({
	name: 'tablaMobileState',
	initialState,
	reducers: {
		modalState: (state, action) => action.payload
	}
});

export const { modalState } = tablaMobileSlice.actions;
export default tablaMobileSlice.reducer;
